import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'antd';
import { OrgChart } from 'd3-org-chart';
import styles from "../styles/CompanyTree.module.css";
import * as d3 from "d3"
import { MinusCircleOutlined, MinusCircleTwoTone, PlusCircleOutlined, PlusCircleTwoTone, ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

const CompanyTree = ({
  positionList = [],
  handleOpenCreateModal = () => { },
  handleOpenEditModal = () => { },
  deletePosition = () => { },
  lang = "",
}) => {
  const svgRef = useRef();
  const [zoomTransform, setZoomTransform] = useState(d3.zoomIdentity);
  const chartRef = useRef(null);
  const [chart, setChart] = useState(null);


  function transformData(data, lang) {
    // console.log("companyInformation", companyInformation);

    const result = [];


    console.log("lang", lang);
    function traverse(node, parentId = null) {

      const transformedNode = {
        ...node,
        id: node.positionId || node.id,
        parentId: parentId || null,
        name: node?.['positionName' + (lang == 'en' ? "En" : "")] || node.name,
        position: node.level || 'Unknown Position',
        image: node.image || '',
        email: node.email || '',
        phone_number: node.phone_number || '',
        hire_date: node.hire_date || '',
        preventExpand: true
      };

      result.push(transformedNode);

      if (node.children && node.children.length > 0) {
        node.children.forEach(child => traverse(child, transformedNode.id));
      }
    }
    data.map(o => traverse(o))
    return result;
  }
  // Function to find node data by nodeId
  function findNodeDataById(chart, nodeId) {
    let nodeData = null;
    console.log("chart", chart?.data().find(o => o.id == nodeId), nodeId);

    chart?.data()?.forEach((node) => {
      if (node.id === nodeId) {
        nodeData = node; // Return the node data
      }
    });

    return nodeData;
  }

  useEffect(() => {
    // Log root data for debugging

    // Check if the root data is valid
    const chartContainer = chartRef.current;

    // Ensure chart container is available
    if (!chartContainer) {
      console.error("Chart container is not available.");
      return;
    }
    // Initialize OrgChart only after container is available
    const orgChart = new OrgChart()
      .nodeHeight((d) => 50 + 25)
      .nodeWidth((d) => 300 + 2)
      .childrenMargin((d) => 200)
      .compactMarginBetween((d) => 200)
      .compactMarginPair((d) => 200)
      .neighbourMargin((a, b) => 200)
      // .onNodeClick(d => { handleOpenEditModal(true, d.data) })
      // .connectionsUpdate(() => {
      //   d3.select(this)
      //     .attr("stroke", "red") // Set your desired link color
      //     .attr("stroke-width", "2")
      //     .attr("stroke-linecap", "round")
      //     .attr('pointer-events', 'none')
      //     .attr("marker-start", (d) => `url(#${d.from + "_" + d.to})`)
      //     .attr("marker-end", (d) => `url(#arrow-${d.from + "_" + d.to})`);
      // })
      .buttonContent(() => { })
      .nodeContent(function (d) {
        const color = '#FFFFFF';
        const imageDiffVert = 25 + 2;
        const iconPlusHtml = ReactDOMServer.renderToString(
          <div
            id={`iconPlusHtml-${d.id}`}  // Unique id based on node data
            // onClick={() => {
            //   console.log("onClick");
            //   handleOpenCreateModal(true, d.data, true); // เปิด modal
            //   handleCloseModal();
            // }} 
            style={{ zIndex: 1000, position: "relative", top: "14px", right: "-145px", width: "30px" }}>
            <PlusCircleTwoTone
              twoToneColor={['#FFFFFF', 'green']}
              className={styles.miniplusBtn} style={{ color: '#3498db', fontSize: '30px' }} />
          </div>); // Render React icon to HTML string
        const iconMinusHtml = ReactDOMServer.renderToString(<div id={`iconMinusHtml-${d.id}`}  // Unique id based on node data
          style={{ zIndex: 1000, position: "relative", bottom: "-45px", right: "-85px", width: "30px" }}

        > {d.data?.id != 'root' && <MinusCircleTwoTone

          twoToneColor={['#FFFFFF', 'red']} className={styles.miniplusBtn} style={{ color: '#3498db', fontSize: '30px' }} />}

        </div>); // Render React icon to HTML string
        return `
          <div id='nodeNa' style="width:${d.width}px;height:${d.height}px;padding-left:1px;padding-right:1px;">
            <div style="font-family: 'Inter', sans-serif;background-color:${color};margin-left:-1px;width:${d.width - 2}px;border-radius:100px;border: 1px solid black ;padding-left :20px;padding-right :20px;">
              <div  id='nodeNa-${d.id}' style="margin-top:20px;min-height:${d.height}px;align-content:center;font-size:1.3vw;color:#08011E;text-align:center ;white-space: normal; word-wrap: break-word; overflow: hidden; text-overflow: ellipsis;padding-left:10px;padding-right:10px;padding-top:20px;">${d.data?.name}
              </div>
              ${iconMinusHtml}
              ${iconPlusHtml}
            </div>
        </div>`;
      })
      .container(chartContainer)
      .data(transformData(positionList, lang))
      .render();

    // Set chart to state for future manipulation (optional)

    // After chart is rendered, attach event listeners using D3
    const svg = d3.select(chartContainer).select("svg");

    if (svg) {
      const defs = svg.append("defs");

      // Update connections with the arrowhead
      // .attr("marker-end", "url(#arrowhead)");
      svg.selectAll(".link")
        .style("stroke", "black"); // Example of dashed links (optional)
      svg.selectAll("foreignObject").remove()
      // console.log(" svg.select('iconPlusHtml')", svg.select('iconPlusHtml'));
      setTimeout(() => {
        // Attach event listener to iconPlusHtml
        d3.selectAll('[id^="iconPlusHtml-"]').on('click', function (event, d) {
          console.log("event.target.id", this.id);

          const nodeId = this.id.replace('iconPlusHtml-', ''); // Get the node ID
          console.log('Icon Plus Clicked on node:', nodeId);
          const nodeData = findNodeDataById(orgChart, nodeId);
          console.log('Node Data for Plus Icon Click:', nodeData?.under?.id);
          handleOpenCreateModal(true, nodeData, !nodeData?.under?.id); // Open create modal for the node
        });
        d3.selectAll('[id^="nodeNa-"]').on('click', function (event, d) {
          const nodeId = this.id.replace('nodeNa-', ''); // Get the node ID
          console.log('Icon Plus Clicked on node:', nodeId);
          const nodeData = findNodeDataById(orgChart, nodeId);
          console.log('Node Data for Plus Icon Click:', nodeData);
          handleOpenEditModal(true, nodeData)
        });

        // Attach event listener to iconMinusHtml
        d3.selectAll('[id^="iconMinusHtml-"]').on('click', function (event) {
          const nodeId = this.id.replace('iconMinusHtml-', ''); // Get the node ID
          const nodeData = findNodeDataById(orgChart, nodeId);
          console.log('Node Data for Plus Icon Click:', nodeData);
          deletePosition(nodeId); // Handle department deletion
        });
      }, 0);
    }

    // orgChart?.expandAll()
    // orgChart?.compact?.(false).render();
    // // Disable the expand/collapse button specifically
    // orgChart.nodeButtonWidth(() => 0).nodeButtonHeight(() => 0).render();
    orgChart.expandAll(false)
      .compact(false)
      .nodeButtonWidth(() => 0)
      .nodeButtonHeight(() => 0)
      .render();
    const rootNodeId = positionList[0]?.positionId; // Assuming the first item is the root
    if (rootNodeId) {
      orgChart.setCentered(rootNodeId);
    }
    setChart(orgChart);
    // Cleanup on component unmount
    return () => {
      if (chart) {
        chart?.destroy?.();
      }
    };
  }, [positionList, lang]);

  return (
    <div>
      <div className={styles.stylesNode}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
          {/* <Button onClick={() => chart.exportImg({ full: true })} style={{ marginRight: 10 }}>
            Download
          </Button> */}
          {/* <Button onClick={() => {
            chart.nodeHeight(() => 125 + 25);
            chart.layout('left').render().fit()
          }}>
            left
          </Button>
          <Button onClick={() => {
            chart.nodeHeight(() => 50 + 25);
            chart.layout('top').render().fit()
          }}>
            top
          </Button> */}
        </div>
        <div id="apexTreeWrapper" style={{ width: "100%" }} ref={chartRef} className="chart-container"></div>
      </div>
    </div>
  );

  //   return data.map((node) => (
  //     <div id="chart">
  //       <Tree
  //         nodePadding="24px"
  //         lineHeight="19px"
  //         label={
  //           <div className={styles.stylesNode}>
  //             {lang == "en" ? node?.positionNameEn : node?.positionName}
  //           </div>
  //         }
  //       >
  //         {node?.children?.length > 0 ? renderTreeNodes(node?.children, lang) : null}
  //       </Tree>
  //     </div>
  //   ));
};

// const renderTreeNodes = (nodes, lang) => {
//   return nodes.map((node) => (
//     <TreeNode
//       key={node.positionId}
//       label={
//         <div className={styles.stylesNode}>
//           {lang == "en" ? node.positionNameEn : node.positionName}
//         </div>
//       }
//     >
//       {node.children.length > 0 ? renderTreeNodes(node.children, lang) : null}
//     </TreeNode>
//   ));
// };

export default CompanyTree;
